import { render, staticRenderFns } from "./NewCoupon.vue?vue&type=template&id=6a0e86c3&scoped=true"
import script from "./NewCoupon.vue?vue&type=script&lang=js"
export * from "./NewCoupon.vue?vue&type=script&lang=js"
import style0 from "./NewCoupon.vue?vue&type=style&index=0&id=6a0e86c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0e86c3",
  null
  
)

export default component.exports